// Modalidad de la última interacción (teclado o puntero), para decidir si el
// foco que pone el código muestra el anillo (Avivador v2, #8; §13 6.2: «nunca
// por foco programático ni con mouse»).
//
// Se recuerda con qué se interactuó por última vez EN CUALQUIER pantalla: al
// volver al Avivador, el último gesto fue el «Volver al Avivador» de la obra.
// Por eso el rastreo se instala a nivel de módulo desde App.tsx (estática, se
// evalúa al arrancar la app) y no al montar la página del mosaico, que es un
// chunk lazy: si no, un click en «Volver al Avivador» después de recargar
// /obras/:cc pasaba antes de que existiera el listener (review de T3a, C5 +
// H6). No es un atajo de teclado: solo anota la modalidad.

export type ModalidadFoco = 'teclado' | 'puntero';

/** null = todavía no hubo interacción: decide la heurística del navegador. */
let ultimaModalidad: ModalidadFoco | null = null;
let rastreoInstalado = false;

/** Idempotente: se puede llamar más de una vez (HMR, tests). */
export function instalarRastreoModalidad(): void {
  if (rastreoInstalado || typeof document === 'undefined') return;
  rastreoInstalado = true;
  document.addEventListener(
    'pointerdown',
    () => {
      ultimaModalidad = 'puntero';
    },
    { capture: true, passive: true },
  );
  document.addEventListener(
    'keydown',
    e => {
      if (!e.metaKey && !e.ctrlKey && !e.altKey) ultimaModalidad = 'teclado';
    },
    { capture: true, passive: true },
  );
}

/** Enfoca sin mover el scroll; sin anillo si lo último fue el mouse o el dedo.
 *  `focusVisible` lo respetan Firefox y Safari. Si todavía no hubo ninguna
 *  interacción (o donde la opción no existe), no se pasa y decide la heurística
 *  del navegador (foco por script después de un click: sin anillo). */
export function enfocarSinScroll(el: HTMLElement): void {
  const opciones: FocusOptions & { focusVisible?: boolean } = { preventScroll: true };
  if (ultimaModalidad) opciones.focusVisible = ultimaModalidad === 'teclado';
  el.focus(opciones);
}
